window.gopuffCustomAnalytics = {
  mapItemDataToEventPayload(item, cartDetails = null) {
    return {
      product_id: item.product_id,
      variant_id: item.variant_id,
      quantity: item.quantity,
      sku: item.sku,
      product_type: item.product_type,
      vendor: item.vendor,
      price: cartDetails ? item.price : String(item.price / 100),
      title: cartDetails
        ? cartDetails.items.find(cartItem => cartItem.variant_id === item.variant_id)?.title ?? item.title ?? null
        : item.title ?? null,
      product_title: cartDetails
        ? cartDetails.items.find(cartItem => cartItem.variant_id === item.variant_id)?.product_title ?? item.product_title ?? null
        : item.product_title ?? null,
      variant_title: cartDetails
        ? cartDetails.items.find(cartItem => cartItem.variant_id === item.variant_id)?.variant_title ?? item.variant_title ?? null
        : item.variant_title ?? null,
    }
  },
  mapAndPublishShopifyCartResponseToCustomAnalyticsEvents(payload) {
    let cartDetails = {
      items: [],
    }

    if (window?.cart?.items) {
      cartDetails.items = JSON.parse(JSON.stringify(window.cart.items));
    }

    if (!Shopify?.analytics?.publish) {
      console.error(`Unable to publish custom analytics event, because no publisher was found.`);
      return;
    }

    try {
      if (payload.items_added.length > 0) {
        payload.items_added.forEach((item) => {
          gopuffCustomAnalytics.publishEvent(`gopuff_product_added_to_cart`, gopuffCustomAnalytics.mapItemDataToEventPayload(item, cartDetails));
        });
      }

      if (payload.items_removed.length > 0) {
        payload.items_removed.forEach((item) => {
          gopuffCustomAnalytics.publishEvent(`gopuff_product_removed_from_cart`, gopuffCustomAnalytics.mapItemDataToEventPayload(item, cartDetails));
        });
      }
    } catch (error) {
      console.error(`Unable to publish custom analytics event, because of error: ${error}`);
    }
  },
  publishCustomAnalyticsEventsByDiff(updates, changeResponse) {
    let preCart = {
      items: [],
    };

    if (window?.cart?.items) {
      preCart.items = JSON.parse(JSON.stringify(window.cart.items));
    }

    if (updates.length === 0) { return; }

    if (!Shopify?.analytics?.publish) {
      console.error(`Unable to publish custom analytics event, because no publisher was found.`);
      return;
    }

    try {
      updates.forEach(update => {
        const itemPreChangeState = preCart.items.find(item => item.variant_id === update.variantId);
        const variantDetailsFromResponse = changeResponse.items.find(item => item.variant_id === update.variantId);

        if (!variantDetailsFromResponse) {
          const variantDetailsFromCart = preCart.items.find(item => item.variant_id === update.variantId);
          if (variantDetailsFromCart) {
            gopuffCustomAnalytics.publishEvent(`gopuff_product_removed_from_cart`, gopuffCustomAnalytics.mapItemDataToEventPayload(variantDetailsFromCart));
          }
        } else if (!itemPreChangeState) {
          gopuffCustomAnalytics.publishEvent(`gopuff_product_added_to_cart`, gopuffCustomAnalytics.mapItemDataToEventPayload(variantDetailsFromResponse));
        } else if (itemPreChangeState && itemPreChangeState.quantity > update.quantity) {
          gopuffCustomAnalytics.publishEvent(`gopuff_product_removed_from_cart`, gopuffCustomAnalytics.mapItemDataToEventPayload({
            ...variantDetailsFromResponse,
            quantity: itemPreChangeState.quantity - update.quantity,
          }));
        } else if (itemPreChangeState && itemPreChangeState.quantity < update.quantity) {
          gopuffCustomAnalytics.publishEvent(`gopuff_product_added_to_cart`, gopuffCustomAnalytics.mapItemDataToEventPayload({
            ...variantDetailsFromResponse,
            quantity: update.quantity - itemPreChangeState.quantity,
          }));
        }
      });
    } catch (error) {
      console.error(`Unable to publish custom analytics event, because of error: ${error}`);
    }
  },
  publishEndpointError(endpoint) {
    gopuffCustomAnalytics.publishEvent(`gopuff_endpoint_error`, { endpoint });
  },
  publishValidationEndpointError(validationRequestData) {
    gopuffCustomAnalytics.publishEvent(`gopuff_validation_endpoint_error`, validationRequestData);
  },
  publishEvent(eventName, eventPayload) {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(eventName, eventPayload);
    }
    document.dispatchEvent(new CustomEvent(eventName, { detail: eventPayload }));

    if (eventName === `gopuff_product_added_to_cart` && window.ShopifyAnalytics?.lib?.track) {
      window.ShopifyAnalytics.lib.track("Added Product", {
        "cartToken": Cookies.get('cart'),
        "variantId": eventPayload.variant_id,
        "productId": eventPayload.product_id,
        "currency": window.ShopifyAnalytics.meta.currency,
        "quantity": eventPayload.quantity,
        "price": eventPayload.price,
        "name": eventPayload.title,
        "sku": eventPayload.sku,
        "brand": eventPayload.brand,
        "variant": eventPayload.variant_title,
        "category": eventPayload.product_type,
        "pageType": window.ShopifyAnalytics.meta?.page?.pageType
      });
    }
  }
}

window.cookieDomain = '.bevmo.com';
window.JsonCookies = {
  get: function (name) {
    var cookie = Cookies.get(name);
    if (cookie) {
      return JSON.parse(cookie);
    }
    return cookie;
  },
  set: function (name, value) {
    return Cookies.set(name, JSON.stringify(value), { domain: cookieDomain, expires: 365 });
  },
  remove: function (name) {
    return Cookies.remove(name, { domain: cookieDomain });
  }
}

const PRODUCTS_RENDERED_EVENT = "products-rendered";
window.productsRenderedEvent = new CustomEvent(PRODUCTS_RENDERED_EVENT);

function onClickDoNotSellMyInformation(e) {
  e.preventDefault();
  const regimes = window?.airgap?.getRegimes() ?? new Set();
  if (regimes.has('CPRA')) {
    window?.transcend?.showConsentManager({ viewState: 'NoticeAndDoNotSell' });
  } else {
    window?.open('https://legal.gopuff.com');
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class QuantityPill extends HTMLElement {
  constructor() {
    super();
    this.quantityEl = this.querySelector('.quantity-pill__quantity');
    this.cartQuantity = parseInt(this.dataset.cartQuantity);
    this.quantity = this.cartQuantity;
    this.variantId = parseInt(this.dataset.variantId);

    this.min = this.dataset.min ? parseInt(this.dataset.min) : null;
    this.max = this.dataset.max ? parseInt(this.dataset.max) : null;
    this.itemInCartEl = this.querySelector('.quantity-pill__item-in-cart');
    this.quickAddButton = this.querySelector('.quantity-pill__quick-add');
    this.alertMeButton = this.querySelector('.quantity-pill__alert-me');

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.header = document.querySelector('sticky-header');

    this.debouncedUpdateCartQuantity = debounce(() => {
      this.updateCartQuantity();
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.querySelector('.quantity-pill__quantity').addEventListener('click', this.onQuantityClick.bind(this));
    if (this.alertMeButton) {
      this.alertMeButton.addEventListener('click', this.onAlertMeClick.bind(this));
    }
  }

  quantityUpdateUnsubscriber = undefined;
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onAlertMeClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const productSku = event.target.dataset.sku;
    const productName = event.target.dataset.name;

    if (Breinify?.plugins?.alertMe?.popup) {
      Breinify.plugins.alertMe.popup(
        {
          product: {
            sku: productSku,
            name: productName,
          },
          location: {
            id: bevmoLocation?.location_id,
            name: bevmoLocation?.fulfillment_display_name,
            fulfillmentType: bevmoLocation?.fulfillment_type,
          }
        },
      );
    }
  }

  onQuantityClick() {
    this.cart.open();
  }

  changeQuantity(quantity) {
    this.quantity = quantity;
    this.quantityEl.innerHTML = gopuffShopify.strings.in_cart_html.replace('{{ quantity }}', this.quantity);
    if (this.quantity == this.cartQuantity) {
      return;
    }
    this.validateQtyRules();

    this.debouncedUpdateCartQuantity();
  }

  updateCartQuantity() {
    this.querySelectorAll('button').forEach((button) => button.disabled = true);

    const updates = [{ variantId: this.variantId, quantity: this.quantity }];
    const cartItems = document.querySelector(`cart-items`) || document.querySelector(`cart-drawer-items`);

    if (!cartItems) { return; }

    cartItems.updateCart(updates, 'quantity-pill', window.gopuffShopify.settings.open_cart_after_atc);
  }

  onCartUpdate(event) {
    if (event.cart) {
      this.cartQuantity = 0;
      for (const item of event.cart.items) {
        if (item.variant_id == this.variantId) {
          this.cartQuantity += item.quantity;
        }
      }
      this.quantity = this.cartQuantity;
      this.quantityEl.innerHTML = gopuffShopify.strings.in_cart_html.replace('{{ quantity }}', this.quantity);

      this.querySelectorAll('button').forEach((button) => button.disabled = false);
      this.validateQtyRules();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!window.bevmoLocation || !window.bevmoLocation.hasAddress()) {
      document.querySelector('location-modal').showModal();
      return;
    };

    if (event.target.name == 'cart') {
      document.querySelector('cart-drawer').open(event.target);
      return;
    }

    if (event.target.name === 'alert_me') {
      return;
    }

    const newValue = this.quantity + (event.target.name === 'minus' ? -1 : 1);
    this.changeQuantity(newValue);
  }

  validateQtyRules() {
    if (!window.bevmoLocation || !window.bevmoLocation.hasAddress()) {
      this.quickAddButton.classList.add('button--black');
      this.quickAddButton.querySelector('span').textContent = 'Enter Address';
      this.quickAddButton.disabled = false;
    }
    else {
      this.quickAddButton.classList.remove('button--black');

      if (this.min != null) {
        const buttonMinus = this.querySelector(".quantity-pill__button[name='minus']");
        buttonMinus.disabled = (this.quantity <= this.min);
      }
      if (this.max != null) {
        const buttonPlus = this.querySelector(".quantity-pill__button[name='plus']");
        buttonPlus.disabled = (this.quantity >= this.max);

        this.quickAddButton.disabled = (this.max == 0);
        this.quickAddButton.querySelector('span').textContent = (this.max == 0) ? gopuffShopify.strings.sold_out : gopuffShopify.strings.add_to_cart;

        if (this.alertMeButton) {
          if (this.max === 0) {
            this.alertMeButton.classList.remove('hidden');
          } else {
            this.alertMeButton.classList.add('hidden');
          }
        }
      }
    }

    if (this.cartQuantity == 0) {
      this.itemInCartEl.classList.add('hidden');
      this.quickAddButton.classList.remove('hidden');
    } else {
      this.itemInCartEl.classList.remove('hidden');
      this.quickAddButton.classList.add('hidden');
    }
  }
}

customElements.define('quantity-pill', QuantityPill);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`overflow-hidden--from-menu-drawer`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove(`overflow-hidden--from-menu-drawer`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (detailsElement) {
      event.preventDefault();
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
        if (this.tagName.toLowerCase() === `header-drawer`) {
          const bottomNav = document.querySelector(`bottom-nav`);
          if (bottomNav) {
            bottomNav.fallbackBottomItems();
          }
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.querySelector('[data-close-header-drawer]').addEventListener('click', (e) => {
      this.closeMenuDrawer(true, this.mainDetailsToggle.querySelector('summary'));
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || (this.closest('.header-wrapper') && this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')) ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      this.mainDetailsToggle.setAttribute(`open`, ``);
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.hasBevmoDotsIndicator = this.querySelectorAll('span.dot')?.length > 0;
    this.bevmoDotsIndicator = this.querySelectorAll('span.dot');

    if (!!this.slider) {
      this.initPages();
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
    }

    if (!!this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  initPages() {
    if (this.sliderItems.length === 0) {
      this.classList.add(`slider-component--loading`);

      return;
    } else {
      this.classList.remove(`slider-component--loading`);
    }

    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) {
      this.classList.add(`slider-component--no-ui`);

      return;
    }

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    if (this.totalPages <= 1) {
      this.classList.add(`slider-component--no-ui`);
      return;
    } else {
      this.classList.remove(`slider-component--no-ui`);
    }

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (this.hasBevmoDotsIndicator) {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (isNaN(this.currentPage) || this.sliderItemOffset === 0 || this.currentPage > this.bevmoDotsIndicator.length) return;

      this.bevmoDotsIndicator.forEach((dot) => dot.classList.remove('active'));
      this.bevmoDotsIndicator[this.currentPage - 1].classList.add('active');
      return;
    }

    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class NonuniformSliderComponent extends SliderComponent {
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderWidth = this.clientWidth;
    this.totalPages = Math.ceil(this.slider.scrollWidth / this.sliderWidth);
    this.update();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const rightBoundary = this.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth <= rightBoundary) && (element.offsetLeft >= this.slider.scrollLeft);
  }

  getVisibilityMap() {
    return this.sliderItemsToShow.map((slide, index) => {
      return {
        isVisible: this.isSlideVisible(slide),
        index,
      };
    });
  }

  getNextHiddenElement() {
    const visibilityMap = this.getVisibilityMap();
    const visible = visibilityMap.filter((item) => {
      return item.isVisible;
    });

    if (visible.length === 0) { return this.sliderItemsToShow[0]; }

    const lastVisibleIndex = visible[visible.length - 1].index;

    if (lastVisibleIndex + 1 === this.sliderItemsToShow.length) {
      return this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    }

    return this.sliderItemsToShow[lastVisibleIndex + 1];
  }

  getPrevHiddenElement() {
    const visibilityMap = this.getVisibilityMap();
    const visible = visibilityMap.filter((item) => {
      return item.isVisible;
    });

    if (visible.length === 0) { return this.sliderItemsToShow[this.sliderItemsToShow.length - 1]; }

    const firstVisibleIndex = visible[0].index;

    if (firstVisibleIndex === 0) {
      return this.sliderItemsToShow[0];
    }

    return this.sliderItemsToShow[firstVisibleIndex - 1];
  }

  onButtonClick(event) {
    event.preventDefault();
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.getNextHiddenElement().offsetLeft
        : this.getPrevHiddenElement().offsetLeft - this.clientWidth + this.getPrevHiddenElement().clientWidth
    this.setSlidePosition(this.slideScrollPosition);
  }
}

customElements.define('nonuniform-slider-component', NonuniformSliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class LogoutLink extends HTMLElement {
  constructor() {
    super();
    this.pendingLogout = false;
  }

  connectedCallback() {
    this.addEventListener('click', this.logout);
  }

  logout(event) {
    event.preventDefault();
    if (this.pendingLogout) return;
    this.pendingLogout = true;

    const loading_overlay = this.querySelector('.loading-overlay');
    if (loading_overlay) loading_overlay.classList.remove('hidden');

    try {
      fetch('https://washington.bevmo.com/account/logout', { mode: 'no-cors' });
      fetch('https://arizona.bevmo.com/account/logout', { mode: 'no-cors' });
      fetch('/cart/clear');
      Cookies.remove('_bevmo_location', { domain: cookieDomain });
      Cookies.remove('_bevmo_state', { domain: cookieDomain });
    }
    finally {
      setTimeout(() => {
        window.location.href = `${window.gopuffShopify.settings.api_base_url}/account/logout?redirect_url=https%3A%2F%2Fbevmo.com%2Faccount%2Flogout`;
      }, 2000);
    }
  }
}

customElements.define('logout-link', LogoutLink);

const HTMLToElement = function (html) {
  const template = document.createElement('template');
  html = html.trim(); // Never return a text node of whitespace as the result
  template.innerHTML = html;

  return template.content.firstChild;
}

const modifyHTML = function (element, callback) {
  const temp_node = document.createElement(`div`);
  temp_node.appendChild(element);
  let html_string = temp_node.innerHTML;
  html_string = callback(html_string);

  return HTMLToElement(html_string)
}

const modifyRawHTML = function (html_string, callback) {
  return HTMLToElement(callback(html_string))
}

function bevmoExpectedStoreByState(state, isStorefrontCheck) {
  if (!isStorefrontCheck && window.gopuffShopify.settings.disableStoreRedirect) { return; }

  const mapByState = {
    AZ: {
      state: `AZ`,
      primary_domain: 'arizona.bevmo.com',
      permanent_domain: 'bevmo-az.myshopify.com',
    },
    WA: {
      state: `WA`,
      primary_domain: 'washington.bevmo.com',
      permanent_domain: 'bevmo-wa.myshopify.com',
    },
  };

  if (mapByState.hasOwnProperty(state)) {
    return mapByState[state];
  }

  const defaultStore = {
    state: `*`,
    primary_domain: 'bevmo.com',
    permanent_domain: 'bevmo-ca.myshopify.com',
  };

  // if (window.location.origin === 'https://store.bevmo.com') {
  //   defaultStore.primary_domain = 'store.bevmo.com';
  // }

  return defaultStore;
}

function filterUnique(value, index, array) {
  return array.indexOf(value) === index;
}

function filterUniqueDeep(value, index, array) {
  const jsonValue = JSON.stringify(value);
  const jsonArray = array.map((val) => JSON.stringify(val));

  return jsonArray.indexOf(jsonValue) === index;
}

function handlePendingEvents() {
  const pendingEvents = JsonCookies.get(`pending_events`) || {};

  for (const [key, value] of Object.entries(pendingEvents)) {
    if ((key === `created_account` || key === `signed_in`) && !window.gopuffShopify.customer) {
      continue;
    }

    gopuffCustomAnalytics.publishEvent(key, value);
  }

  JsonCookies.set(`pending_events`, {});
}

handlePendingEvents();
